import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
  FormViewServiceProvider,
  vsServiceName as FormViewServiceName,
  vsProviderName as FormViewServiceProviderName,
} from "../../../../records/forms/formView";
import { RecordDataSource } from "../../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../../records/views/recordGridView";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName as LookupManagementServiceProviderName } from "../../../shared/lookups";
import {
  LookupManagementConfig,
  LookupManagementServiceProvider,
} from "../../../../records/lookup/lookupManagement";
import {
  MachineContractType,
  MachineConversionType,
} from "../../models/machineConfiguration";

export const vsObjectName = "machineConversionType";

const url = "/api/machines/MachineConversionType";

export function machineConversionTypeLookupConfig(
  lookupManagementServiceProvider: LookupManagementServiceProvider,
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  configureLookupManagement(lookupManagementServiceProvider);
  configureForm(formViewServiceProvider);
  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    getGridConfig
  );
}
machineConversionTypeLookupConfig.$inject = [
  LookupManagementServiceProviderName,
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
];

function configureForm(formViewServiceProvider: FormViewServiceProvider) {
  formViewServiceProvider.addFormViewConfig(vsObjectName, [
    FormViewServiceName,
    (formViewService: FormViewService): FormViewConfig => {
      return {
        fields: [
          fieldHelpers.simpleStringField({
            key: "Name",
            name: "Name",
            label: "Conversion Type",
            required: true,
          }),
        ],
        name: vsObjectName,
        submitForm: (args: FormSubmitArgs) => {
          const model = <MachineConversionType>args.model;
          return formViewService.saveForm({
            formObject: model,
            formViewController: args.formViewController,
            url: url,
          });
        },
        title: (model: MachineConversionType) =>
          model.Id ? "Edit Conversion Type" : "Create Conversion Type",
      };
    },
  ]);
}

function configureLookupManagement(
  lookupManagementServiceProvider: LookupManagementServiceProvider
) {
  lookupManagementServiceProvider.addLookup(vsObjectName, {
    displayName: "Conversion Type",
    config: [
      ServerUtilityName,
      (serverUtility: ServerUtility): LookupManagementConfig => {
        return {
          fetchFormModel: (id: number) =>
            serverUtility.querySingle({
              url,
              query: { Id: id },
            }),
          baseUrl: url,
        };
      },
    ],
  });
}

function getGridConfig(
  serverUtility: ServerUtility,
  columnDefinitionService: ColumnDefinitionService
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Conversion Type",
      }),
    ],
    gridDataSource: new RecordDataSource(serverUtility, url),
    defaultSort: "Name",
    namePlural: "Conversion Types",
    nameSingular: "Conversion Type",
    showAddButton: true,
    showAddButtonPermission: "machineLookupModify",
    showSelectButtons: false,
  };
}
getGridConfig.$inject = [ServerUtilityName, ColumnDefinitionServiceName];
